enum Position{
    Top,
    Bottom,
    Left,
    Right,
    Middle,
    Center
}

export default Position;